import { createContext, useCallback, useContext, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import type { AlertColor } from '@mui/material/Alert';

export type ToastContextType = {
    /** Show a brief snackbar. Defaults to a success message. */
    notify: (message: ReactNode, severity?: AlertColor) => void;
};

export const ToastContext = createContext<ToastContextType>({
    notify: () => {}
});

export function useToast() {
    return useContext(ToastContext);
}

/** Convenience for the common "saved" feedback: a localized success toast. */
export function useSavedToast() {
    const { notify } = useToast();
    const intl = useIntl();
    return useCallback(
        () => notify(intl.formatMessage({ id: 'common.saved' })),
        [notify, intl]
    );
}
